import { Schema as S } from "effect";

export const DeletePartnerScheduleRequestSchema = S.Struct({
  _id: S.String,
});

export type DeletePartnerScheduleRequest = S.Schema.Type<
  typeof DeletePartnerScheduleRequestSchema
>;
